// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__160w-solar-panel_productcontent__5bpSg"};